export default "__VITE_ASSET__8129f3df__"